import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Dimmer, Loader, Modal } from 'semantic-ui-react';
import { useDataModelerContext } from '../../DataModelerContext';

const TransparentDimmer = styled(Dimmer)`
  &&& {
    background: transparent !important;
  }
`;

const TICK_SECONDS = 2;

const calculatePercentsPerTick = (ttlSeconds: number) => {
  const numTicks = ttlSeconds > 0 ? ttlSeconds / TICK_SECONDS : 100;
  const percentPerTick = Math.floor(100 / numTicks);
  return percentPerTick < 1 ? 1 : percentPerTick;
};

const ProgressLoaderModal = () => {
  const { progressText, lockedTtlSeconds, handleLockedTtlExpired } =
    useDataModelerContext();
  const percentPerTick = calculatePercentsPerTick(lockedTtlSeconds);
  const [currentPercent, setCurrentPercent] = useState(0);

  const loadingText = `${progressText} (${currentPercent}%)`;

  // start an interval timer which will eventually call onComplete at 99%
  useEffect(() => {
    const myInterval = setInterval(() => {
      setCurrentPercent((curVal) => {
        const nextPercent = curVal + percentPerTick;
        if (nextPercent > 99) {
          if (lockedTtlSeconds > 0) {
            handleLockedTtlExpired();
          }
          return 99;
        } else {
          return nextPercent;
        }
      });
    }, TICK_SECONDS * 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [
    percentPerTick,
    setCurrentPercent,
    lockedTtlSeconds,
    handleLockedTtlExpired,
  ]);

  return (
    <Modal open>
      <TransparentDimmer active>
        <Loader size="medium">{loadingText}</Loader>
      </TransparentDimmer>
    </Modal>
  );
};

export default ProgressLoaderModal;
